import React from "react";
import { TABLE_LIMIT } from "../../layouts/ArticleTable/ArticleTable";
import { V2Table } from "./Table";
export function DrawerTable({ headings, data, rowKey, pagination, dataId, dataTestId, }) {
    const rowDrawerOffset = pagination?.drawerOffset.filter((drawer) => drawer.key === rowKey)[0];
    const rowOffset = rowDrawerOffset?.offset ?? 0;
    return (React.createElement(V2Table, { dataTestId: dataTestId, dataId: dataId, headings: headings, data: data, styling: "subdued", childTable: true, pagination: pagination && {
            offset: rowOffset,
            setOffset: (offset) => pagination && pagination?.setOffset({ offset, key: rowKey }),
            limit: pagination?.limit || TABLE_LIMIT,
            maxPagesDisplayed: 7,
            totalRecords: pagination?.totalRecords,
        } }));
}
